// extracted by mini-css-extract-plugin
export default {"container":"QB19W","input":"snehD"};